


export default class {
    constructor(windowPal, $body) {
        this.windowPal = windowPal;
        this.$body = $body;
        this.viewportHeight = null;
        this.$backToTopBtn = $("#scroll-to-top");
        // console.log(this.$backToTopBtn[0]);
        if (this.$backToTopBtn.length) {
            windowPal.resize(()=>{
                this.resize();
            });
            windowPal.scroll(()=>{
                this.scroll();
            });
            this.resize();
            this.scroll();
            this.$backToTopBtn.find('img').click(()=>{
                this.$body.animate({scrollTop: 0}, 1000);
            });
        }
    }
    scroll() {
        let pos = this.windowPal.$.scrollTop(),
            threshold = this.viewportHeight * 1.2;
        // console.log(pos, threshold);
        if (pos > threshold) {
            $(this.$backToTopBtn).addClass("show");
        } else {
            $(this.$backToTopBtn).removeClass("show");
        }
    }
    resize() {
        this.viewportHeight = parseInt(this.windowPal.$.height());
    }
}


// WEBPACK FOOTER //
// ./scripts/lib/ScrollToTop.js